import { DirectAnswerStatus, IDirectAnswerResult } from '../../../api/types';

export const isDirectAnswerReady = (directAnswer?: IDirectAnswerResult): directAnswer is IDirectAnswerResult =>
    directAnswer?.status === DirectAnswerStatus.DONE;
